var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-loader',{attrs:{"height":226,"width":750}},[_c('rect',{attrs:{"x":"0","y":"60","rx":"0","ry":"0","width":"130","height":"100"}}),_c('rect',{attrs:{"x":"160","y":"60","rx":"0","ry":"0","width":"580","height":"120"}})])}
var staticRenderFns = []

export { render, staticRenderFns }